var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-console */
import { Check, Close, ContentCopy, Create, DeleteOutline } from '@mui/icons-material';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteWebhooksAction } from '../../../../api/action/webhook.action';
import { QUERY_KEY } from '../../../../api/types/query.type';
import ShopifyLogo from '../../../../assets/icons/shopifyLogo.svg';
import UspacyLogo from '../../../../assets/icons/uspacyLogo.svg';
import { WebhookForm } from '../../../../components/Forms';
import { useSettings } from '../../../../context';
import { WebhookSite } from '../../../../types/webhooks.type';
import { copyWebhookValue } from './helpers';
import { theme } from './theme';
var AlertComponent = lazy(function () { return import('../../../../components/UIcomponents/AlertComponent/AlertComponent'); });
var ButtonComponent = lazy(function () { return import('../../../../components/UIcomponents/ButtonComponent/ButtonComponent'); });
var WebhookInfo = function (_a) {
    var webhooks = _a.webhooks, shopId = _a.shopId;
    var _b = useState(false), needToShowDeleteShopAlert = _b[0], setNeedToShowDeleteShopAlert = _b[1];
    var _c = useState(false), isEditingUspacy = _c[0], setIsEditingUspacy = _c[1];
    var t = useTranslation('settings').t;
    var _d = useSettings(), userPortal = _d.userPortal, setShopSettings = _d.setShopSettings;
    var handleDeleteWebhookAlert = function () {
        setNeedToShowDeleteShopAlert(!needToShowDeleteShopAlert);
    };
    var queryClient = useQueryClient();
    var _e = useMutation({
        mutationFn: deleteWebhooksAction,
        onSuccess: function () {
            setShopSettings(function (prev) { return (__assign(__assign({}, prev), { isWebhookAdded: false, isExtraSettingsAdded: false })); });
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEY.GET_WEBHOOKS, userPortal],
            });
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEY.GET_EXTRASETTINGS, userPortal],
            });
        },
        onError: function (error) {
            // Handle delete webhook errors
            console.error('Failed to delete webhook:', error);
        },
    }), deleteWebhook = _e.mutate, isDeletingWebhook = _e.isPending;
    var handleWebhookUpdate = function () {
        setIsEditingUspacy(false);
    };
    return (_jsx(Box, { sx: theme.container, children: webhooks.map(function (webhook) {
            var isUspacy = webhook.webhook_site === WebhookSite.USPACY;
            var isActive = webhook.is_active;
            var title = isUspacy ? t('webhook.uspacy') : t('webhook.shopify');
            return (_jsxs(Paper, { sx: theme.paper, children: [_jsxs(Box, { sx: theme.webhookInfo, children: [_jsxs(Box, { sx: theme.titleContainer, children: [_jsx(Box, { component: "img", src: isUspacy ? UspacyLogo : ShopifyLogo, alt: webhook.webhook_site, sx: theme.logo }), _jsx(Typography, { sx: theme.title, children: title })] }), isActive ? _jsx(Check, { sx: theme.activeIcon }) : _jsx(Close, { sx: theme.inactiveIcon })] }), isUspacy && _jsx(AlertComponent, { type: "warning", message: t('webhook.cronIntervalInfo') }), isUspacy && isEditingUspacy ? (_jsx(WebhookForm, { shopId: shopId, onWebhookCreated: handleWebhookUpdate, onCancel: handleWebhookUpdate, webhookValue: webhook.webhook_value, isUpdateMode: true, webhookId: webhook._id })) : (_jsxs(Box, { sx: theme.webhookValueContainer, children: [_jsx(Typography, { sx: theme.webhookValue, children: webhook.webhook_value }), _jsxs(Box, { sx: theme.controlsContainer, children: [_jsx(IconButton, { sx: theme.copyIcon, onClick: function () { return copyWebhookValue(webhook.webhook_value); }, children: _jsx(ContentCopy, {}) }), isUspacy && (_jsx(IconButton, { sx: theme.editIcon, onClick: function () { return setIsEditingUspacy(function (prev) { return !prev; }); }, children: _jsx(Create, {}) })), isUspacy && (_jsx(IconButton, { sx: theme.deleteIcon, onClick: handleDeleteWebhookAlert, children: _jsx(DeleteOutline, {}) }))] })] })), isUspacy && _jsx(AlertComponent, { type: "info", message: t('webhook.customFieldsInfo') }), isUspacy && (_jsx(Box, { sx: {
                            visibility: needToShowDeleteShopAlert ? 'visible' : 'hidden',
                            height: needToShowDeleteShopAlert ? 'auto' : '0px',
                            overflow: 'hidden',
                        }, children: _jsx(AlertComponent, { type: "warning", style: { fontSize: '18px' }, message: t('webhook.confirmDeleteMessage'), component: _jsxs(Box, { style: { display: 'flex', gap: '10px' }, children: [_jsx(ButtonComponent, { title: t('common.cancel'), stylesType: "cancel", handleClick: handleDeleteWebhookAlert }), _jsx(ButtonComponent, { title: t('common.confirm'), handleClick: function () { return deleteWebhook(shopId); }, isDisabled: isDeletingWebhook })] }) }) })), !isUspacy && !needToShowDeleteShopAlert && _jsx(AlertComponent, { type: "warning", message: t('webhook.shopifyHowToSetWebhook') })] }, webhook.webhook_value));
        }) }));
};
export default WebhookInfo;
